export default function(array, key) {
  const newArray = [...array]

  for (const index in array) {
    if (array.hasOwnProperty(index)) {
      newArray[`ID_${array[index][key]}`] = array[index]
    }
  }

  return newArray
}
